/**
 *
 * SideBar
 *
 */
import * as React from 'react';

import { useSelector } from 'react-redux';
import { selectSiteMapSettings } from 'app/slice/selectors';
import { SideBarMenu } from './SideBarMenu';
import { SideBarHeader } from './SideBarHeader';
import { SiteMapNode, SiteMapProvider } from 'types/SiteMapSettings';
import { isNullOrUndefined } from 'utils/typeUtils';
import { useLocation } from 'react-router-dom';
import { SideBarFooter } from './SideBarFooter';
import { SideBarQuickAction } from './SideBarQuickAction';
import { selectRouterPathname } from 'app/slice/router-selectors';
interface Props {
  isOpen: boolean;
  isMobile?: boolean;
}

const SideBarComponent = (props: Props) => {
  const { isOpen, isMobile } = props;
  const siteMapSettings = useSelector(selectSiteMapSettings);
  const [currentNode, setCurrentNode] = React.useState<SiteMapNode | undefined>(
    undefined,
  );
  const routerPathName = useSelector(selectRouterPathname);
  const location = useLocation();
  const [currentNodes, setCurrentNodes] = React.useState<SiteMapNode[]>([]);
  const loading = isNullOrUndefined(siteMapSettings);
  React.useEffect(() => {
    setCurrentNode(() =>
      new SiteMapProvider(siteMapSettings).getCurrentMainNode(
        location?.pathname || routerPathName || window.location.pathname,
      ),
    );
  }, [location?.pathname, routerPathName, siteMapSettings]);
  React.useEffect(() => {
    let active = !isNullOrUndefined(siteMapSettings);
    if (currentNodes.length > 0) {
      return undefined;
    }
    if (active) {
      let siteMapProvider = new SiteMapProvider(siteMapSettings);
      setCurrentNode(() =>
        siteMapProvider.getCurrentMainNode(
          location?.pathname || routerPathName || window.location.pathname,
        ),
      );
      setCurrentNodes(
        siteMapProvider.getCurrentNodes(
          location?.pathname || routerPathName || window.location.pathname,
        ),
      );
    }
    return () => {
      active = false;
    };
  }, [currentNodes, loading, location, routerPathName, siteMapSettings]);
  return (
    <React.Fragment>
      <SideBarHeader isOpen={isOpen} />
      <SideBarQuickAction isOpen={isOpen} isMobile={isMobile} />
      <SideBarMenu
        menuItems={currentNodes}
        isOpen={isOpen}
        currentNode={currentNode}
        loading={loading}
        isMobile={isMobile}
      />
      {isMobile && <SideBarFooter />}
    </React.Fragment>
  );
};
export const SideBar = React.memo(SideBarComponent);
